<div class="tableComponent">
  <mat-table
    matMultiSort
    [multiTemplateDataRows]="hasDetailsRow$ | async"
    [dataSource]="dataSource"
    (matSortChange)="table.onSortEvent()"
  >
    <ng-container *ngFor="let column of columns; trackBy: trackColumnFn" matColumnDef="{{ column.name }}">
      <mat-header-cell
        *matHeaderCellDef="let element"
        [ngClass]="getColumnCssClass(column.header, element)"
        [class.not-clickable]="column.disableSorting"
        [mat-multi-sort-header]="sortHeaderFor(column)"
      >
        <table-header [element]="element" [header]="column.header"> </table-header>
      </mat-header-cell>

      <mat-cell *matCellDef="let element" [ngClass]="getColumnCssClass(column.table, element)">
        <table-column [element]="element" [table]="column.table"> </table-column>
      </mat-cell>
    </ng-container>

    <ng-container *ngIf="hasDetailsRow$ | async" matColumnDef="expandedDetail">
      <mat-cell *matCellDef="let element" [attr.colspan]="(displayedColumnNames$ | async).length">
        <div class="detail-table-row-content" [@detailExpand]="rowIsSelected(element) ? 'expanded' : 'collapsed'">
          <table-column [element]="element" [table]="tableDefinition.detailsRow"> </table-column>
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumnNames$ | async; sticky: stickyHeader"></mat-header-row>
    <mat-row
      *matRowDef="let rowDataElement; columns: displayedColumnNames$ | async"
      (click)="rowClickHandler(rowDataElement)"
      (mouseover)="mouseOverHandler(rowDataElement)"
      [ngClass]="[getSelectedRowClass(rowDataElement), getRowClass(rowDataElement)]"
      [class.detail-table-row-pre-row]="hasDetailsRow$ | async"
    >
    </mat-row>
    <ng-container *ngIf="hasDetailsRow$ | async">
      <mat-row
        *matRowDef="let rowDataElement; columns: ['expandedDetail']"
        class="detail-table-row"
        (click)="rowClickHandler(rowDataElement)"
      >
      </mat-row>
    </ng-container>
  </mat-table>

  <div class="not-found" *ngIf="isNoDataDisplayed()" [translate]="'leitstand.log.notFound'"> </div>
</div>
